import {NotifyUserHasChangedUseCase} from './core/user/application/notify-user-has-change.use-case';
import {Injectable} from '@angular/core';
import {DeepLinkViewModel} from "@app/deep-link.view-model";
import {ReplaySubject, Subject} from "rxjs";
import {
    ShouldDisplayDownloadAppMessageUseCase
} from "@app/core/user-marketing-rules/application/should-display-download-app-message-use-case";

@Injectable()
export class AppViewModel {

    readonly isDeepLinkLoading$ = this.deepLinkViewModel.isLoading$;

    readonly navigationAction$ = this.deepLinkViewModel.navigationAction$;

    // ReplaySubject ensures the event is received even if subscribed later.
    readonly displayDownloadAppModalEventsSubject = new ReplaySubject<void>();
    readonly displayDownloadAppModalEvents$ = this.displayDownloadAppModalEventsSubject.asObservable();

    constructor(
        private notifyUserHasChanged: NotifyUserHasChangedUseCase,
        private deepLinkViewModel: DeepLinkViewModel,
        private shouldDisplayDownloadAppMessageUseCase: ShouldDisplayDownloadAppMessageUseCase,
    ) { }

    init() {
        this.notifyUserHasChanged.execute();
        this.deepLinkViewModel.init();
        this.checkAndDisplayDownloadAppModal();
    }

    /**
     * Checks whether the "Download App" modal should be displayed and triggers it if necessary.
     */
    private checkAndDisplayDownloadAppModal() {
        this.shouldDisplayDownloadAppMessageUseCase.execute().subscribe({
            next: shouldDisplay => {
                if (shouldDisplay) {
                    this.displayDownloadAppModalEventsSubject.next();
                }
            }
        });
    }

    destroy() {
        this.deepLinkViewModel.destroy();
    }
}
